// extracted by mini-css-extract-plugin
export var activeButton = "SYaD8";
export var activeFilledOnHoverButton = "wprGU";
export var buttonBadge = "PGfB8";
export var buttonFullBleed = "oq3St";
export var buttonIcon = "jxKmP";
export var filledOnHoverButton = "qJDsp";
export var headerButton = "TXRvx";
export var headerButtonGroup = "I64F8";
export var menuItemBadge = "Xd9dp";
export var overflowContainer = "rO0nz";
export var wideContentButton = "IIaLq";
export var wideContentIcon = "PjkM4";